
namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class DataReportsGrid extends SiteEntityGrid<DataReportsRow, any> {
        protected getColumnsKey() { return 'Data.DataReports'; }
        protected getDialogType() { return DataReportsDialog; }
        protected getIdProperty() { return DataReportsRow.idProperty; }
        protected getLocalTextPrefix() { return DataReportsRow.localTextPrefix; }
        protected getService() { return DataReportsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}